import { createContext } from 'react';

export const CloseMainDropdownContext = createContext(() => {});
